import axios from "../../../utils/authAxios";
const api_base_url = process.env.REACT_APP_API_BASEURL;

export const getScripts = async () => {
  const { data } = await axios.get(
    `${api_base_url}/Configuration/ScriptConfiguration`
  );
  return data;
};

export const getScriptContent = async (path) => {
  const { data } = await axios.get(
    `${api_base_url}/Configuration/ScriptContent?path=${path}`
  );
  return data;
};

export const editScript = async (scriptData) => {
  const { data } = await axios.put(
    `${api_base_url}/Configuration/UpdateScript`,
    scriptData
  );
  return data;
};

export const getFolderPath = async () => {
  const { data } = await axios.get(
    `${api_base_url}/Configuration/GetFolderPath`
  );
  return data;
};
